<div class="m-0 p-0 w-100">
    <app-session-logout *ngIf="configService.isSessionExpired"></app-session-logout>
     <app-logout *ngIf="configService.isShowLogOutConfirm"></app-logout>
    <router-outlet></router-outlet>
</div>
